import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

function DragTextDragOver() {
	const { t } = useTranslation();
	return (
		<Typography variant="subtitle2">
			{t('report.achievements.addFileModal.selectOrDrop')}
		</Typography>
	);
}

export default DragTextDragOver;
